export const bytestreamType="bytestream"

export const streamType = 'stream'
export const nameSingular = "bytestream.name_singular"

export type FileType = {
    mime: string,
    name: string
}